// @ts-nocheck
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { changeErrorModalProps } from '../../../redux/actions/global';
import ErrorModal from '../ErrorModal/ErrorModal';

class ErrorBoundary extends Component {
    state = {
        error: '',
        errorInfo: '',
        hasError: false,
    };

    componentDidCatch(error, errorInfo) {
        console.error(errorInfo);
        this.setState({ errorInfo, hasError: true });
        this.props.changeErrorModalProps({
            isVisible: true,
            error: { title: 'Something went wrong.', description: 'Please reload page' },
        });
    }

    render() {
        const { hasError } = this.state;

        return (
            <>
                {hasError ? null : this.props.children}
                <ErrorModal />
            </>
        );
    }
}

const mapDispatchToProps = {
    changeErrorModalProps,
};

export default connect(null, mapDispatchToProps)(ErrorBoundary);
